import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const profileStyle = style({
  gap: theme.spacings.s,
});
